import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AuthenticationService } from './../../_services/authentication.service';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../_services/loader.service';
import { EncrDecrService } from '../../_services/encr-decr.service';
import { CONFIG } from '../../config/app-config';
import {Location} from '@angular/common';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {
  @ViewChild('forgotPassModal', {static: true}) public forgotPassModal: ModalDirective;
  loginForm: FormGroup;
	forgotPassWordForm: FormGroup;
	returnUrl: string;
  loading = false;
  forgotPassLoading = false;
  isForgotModalShown: Boolean = false;

  public passwordFieldType: string = 'password';
  public eyeIconClass: string = 'fa fa-eye-slash';

  constructor( private authenticationService: AuthenticationService, 
    private route: ActivatedRoute, 
    private router: Router, 
    private toastr: ToastrService,
    private loader: LoaderService,
    private EncrDecr: EncrDecrService,
    private _location: Location ) { }

	ngOnInit() {
    this.authenticationService.removeOtpDetails();
    //  Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))
    //  @((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)
    //  +[a-zA-Z]{2,}))$/)
    //  login form
		this.loginForm = new FormGroup({
  		'email': new FormControl(null, [Validators.required]),
      'password': new FormControl(null, [Validators.required]),
      'rememberMe': new FormControl()
    });
    const encrypted = localStorage.getItem('remData');
    const getRemData = this.EncrDecr.get(CONFIG.EncrDecrKey, encrypted);
    if (getRemData && getRemData !== 'null') {
        const parseData = JSON.parse(getRemData);
        this.loginForm.controls['email'].setValue(parseData.email);
        this.loginForm.controls['password'].setValue(parseData.pass);
        this.loginForm.controls['rememberMe'].setValue(parseData.rem);
    }
    // for auto sign up (please remove after start api integration)
    // this.loginForm.controls['email'].setValue('rahul.trivedi@brainvire.com');
    // this.loginForm.controls['password'].setValue('admin123');
    // this.onSubmit();
    /// end
    
    // forgot password form
    this.forgotPassWordForm = new FormGroup({
      'forgotPassemail': new FormControl(null, [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
    });

    // reset login status
    const decrypted = localStorage.getItem('currentUser');
		const currentUser = this.EncrDecr.get(CONFIG.EncrDecrKey, decrypted);
    if (currentUser) {
      this._location.back();
    } else {
      this.authenticationService.logout();
 
      // get return url from route parameters or default to '/'
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }
    

	}

	onSubmit() {

    // stop here if form is invalid
    if (this.loginForm.invalid) {
        return;
    }
    this.loading = true;
    this.loader.showLoader();
		const email = this.loginForm.value.email;
    const password = this.loginForm.value.password;
    const rememberMe = this.loginForm.value.rememberMe;     
		this.authenticationService.login(email, password)
      .pipe(first())
      .subscribe(
          data => {
            this.loader.hideLoader();
              if (data.meta.status) {
                if (rememberMe) {
                  const rememberData = {
                    email: email,
                    pass: password,
                    rem: rememberMe
                  };
                  const encrypted = this.EncrDecr.set(CONFIG.EncrDecrKey, rememberData);
                  localStorage.setItem('remData', encrypted);
                } else {
                  localStorage.removeItem('remData');
                  localStorage.removeItem('tabStatus');
                  localStorage.removeItem('parent_id');
                  localStorage.removeItem('tabStaDoc');
                  localStorage.removeItem('tabStaFar');
                }
                this.toastr.success(data.meta.message);
                if (data.meta.message_code === "ADMIN_OTP_SENT") {
                  this.router.navigate(['/verifyotp']);
                } else {
                  this.authenticationService.setLoggedIn(true);
                  this.router.navigate([this.returnUrl]).then(() => {
                    localStorage.removeItem('settings');
                    localStorage.removeItem('theme');
                    window.location.reload();
                  });
                  
                }
              }
          },
          error => {
            this.loader.hideLoader();
            const responseData = error;
            if (responseData.meta) {
                this.toastr.error(responseData.meta.message);
            } else {
                this.toastr.error('Something went wrong please try again.');
            }
            this.loading = false;
    });
	}

	ngAfterViewInit() {
		// Remove fixed sidebar and header classes from body
		document.querySelector('body').classList.remove('sidebar-fixed', 'aside-menu-fixed', 'sidebar-lg-show', 'header-fixed');
	}
  showForgotModal(): void {
    this.forgotPassWordForm.reset();
    this.isForgotModalShown = true;
  }
  hideForgotModal(): void {
    this.isForgotModalShown = false;
  }
  onForgotHidden(): void {
    this.isForgotModalShown = false;
  }
  forgotPassword() {
    // stop here if form is invalid
    if (this.forgotPassWordForm.invalid) {
        return;
    }
    this.forgotPassLoading = true;
    const forgotPassemail = this.forgotPassWordForm.value.forgotPassemail;
    this.loader.showLoader();
    this.authenticationService.forgotPassword(forgotPassemail)
      .pipe(first())
      .subscribe(
          data => {
            this.loader.hideLoader();
              if (data.meta.status) {
                this.forgotPassWordForm.reset();
                this.isForgotModalShown = false;
                this.forgotPassLoading = false;
                this.toastr.success(data.meta.message);
              }
          },
          error => {
            this.loader.hideLoader();
            if (error && error.meta) {
              this.toastr.error(error.meta.message);
            } else {
                this.toastr.error('Something went wrong please try again.');
            }
            this.forgotPassLoading = false;
    });
  }

  public togglePasswordField(): void {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    this.eyeIconClass = this.eyeIconClass === 'fa fa-eye' ? 'fa fa-eye-slash' : 'fa fa-eye';
  }
}
